module.exports = __webpack_public_path__ + "img/about.6cc36f3a.svg";